import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useCart } from '../../../context/CartContext'
import formatMoney from '../../../util/formatMoney'
import { IMAGE_URL } from '../../../constants'
import * as S from './styles'
import { ProductCartQuantity } from '../../ProductCartQuantity'
import IncrementStepper from '../../IncrementStepper'

const CatalogProductCard = ({ product, isCategoryPage }) => {
  const { addProductChatbotCart, deleteProductChatbotCart, chatbotCart, chatbotCartObj } = useCart()
  const customer = JSON.parse(localStorage.getItem('DAuth:customer'))
  const showProductPromotionInPortal = customer?.environmentConfiguration?.showProductPromotionInPortal
  const [qty, setQty] = useState(0)
  const [inicialQty, setInicialQty] = useState(0)

  let firstImage = '/assets/images/empty-image.png'
  if (product.images && product.images.length > 0) {
    if (product.images[0].includes('http')) { firstImage = product.images[0] } else { firstImage = `${IMAGE_URL}${product.images[0]}` }
  }

  useEffect(() => {
    const findProductOnCart = chatbotCart?.items?.find(item => item.productId === product.id)
    if (findProductOnCart) {
      setInicialQty(findProductOnCart.quantity)
    } else if (chatbotCartObj && chatbotCartObj[product.id]) {
      setInicialQty(chatbotCartObj[product.id])
    } else {
      setInicialQty(0)
    }
  }, [product, chatbotCart, chatbotCartObj])

  useEffect(() => {
   setQty(chatbotCartObj[product.id] ?? 0)
  }, [chatbotCartObj])

  return (
    <S.CatalogProductCard $isCategoryPage={isCategoryPage}>
      <S.ImageWrapper $isCategoryPage={isCategoryPage}>
        { inicialQty > 0 && <ProductCartQuantity qtd={inicialQty} moreProductsCarrossel={true}/> }
        <S.Image src={firstImage} alt={product.description} />
      </S.ImageWrapper>
      <S.Title>
        {product.description}
        {product.multiplicationFactor > 1 ? <S.SubTitle> (x{product.multiplicationFactor})</S.SubTitle> : <></>}
      </S.Title>
      <S.ProductInfo>
        {
          showProductPromotionInPortal && product.originalPrice > product.price &&
          <S.OriginalPriceWrapper>
            <S.OriginalPrice>R$ {formatMoney(product.originalPrice, false)}</S.OriginalPrice>
          </S.OriginalPriceWrapper>
        }
        <S.PriceWrapper>
          por R$ <S.Price>{formatMoney(product.price, false)}</S.Price>
        </S.PriceWrapper>
        <S.StepperWrapper>
          <IncrementStepper qty={qty} setQty={setQty} isChatbotCatalog/>
          {inicialQty > 0 && (
            <S.DeleteButton onClick={() => {
              deleteProductChatbotCart(product.id, true);
              toast.success('Produto removido do pedido!', {
                position: 'top-right',
              });
            }}>
              <S.DeleteIcon type='trash' />
            </S.DeleteButton>
          )}
        </S.StepperWrapper>
        <S.BuyButton onClick={() => {
          if (qty > 0) {
            addProductChatbotCart(product.id, qty);
            toast.success('Produto adicionado ao pedido!', {
              position: 'top-right',
            });
          } else {
            deleteProductChatbotCart(product.id, true);
            toast.success('Produto removido do pedido!', {
              position: 'top-right',
            });
          }
        }}>
          Adicionar ao pedido
        </S.BuyButton>
      </S.ProductInfo>
    </S.CatalogProductCard>
  )
}

export default CatalogProductCard
